import Icon from 'veui/components/Icon'
import { IconShrink } from 'dls-icons-vue'

Icon.register('shrink', IconShrink)
